import { CollectionResource } from 'dy-frontend-http-repository/lib/data/resources';
import { ClientUserTeamConnectionsResource } from 'dy-frontend-http-repository/lib/modules/ClientUser/resources';

import domain from './domain';
import { resetTeamConnections } from './events';

// Team connections
export const $teamConnections = domain
    .createStore<CollectionResource<ClientUserTeamConnectionsResource, {}> | null>(null)
    .reset(resetTeamConnections);
